/**
 * @generated SignedSource<<45042c438f3f073e8b3f26efabec443a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PassengerDocument_document$data = {
  readonly file: {
    readonly fileName: string;
  } | null;
  readonly name: string;
  readonly uuid: string;
  readonly " $fragmentType": "PassengerDocument_document";
};
export type PassengerDocument_document$key = {
  readonly " $data"?: PassengerDocument_document$data;
  readonly " $fragmentSpreads": FragmentRefs<"PassengerDocument_document">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PassengerDocument_document",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoredFile",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PassengerDocument",
  "abstractKey": null
};

(node as any).hash = "0e74bf03c802bb084b13b0c99274f808";

export default node;
